import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Spinner from 'react-bootstrap/Spinner';
import { formatDate } from '../../../common/utils';
import { toast } from 'react-toastify';

import '../modals.css';

const AddEvent = ( { close, aid, uid, cid, pType, events, contacts, load, addToEvent, createEvent } ) => {
    const [ name, setName ] = useState( '' );
    const [ location, setLocation ] = useState( '' );
    const [ eventDate, setEventDate ] = useState( '' );
    const [ startTime, setStartTime ] = useState( '' );
    const [ endTime, setEndTime ] = useState( '' );
    const [ type, setType ] = useState( '' );
    const [ details, setDetails ] = useState( '' );
    const [ regOption, setRegOption ] = useState( 'none' );
    const [ regLink, setRegLink ] = useState( '' );
    const [ ready, setReady ] = useState( false );
    const [ loading, setLoading ] = useState( true );
    const [ elist, setElist ] = useState( [] );
    const [ processing, setProcessing ] = useState( false );
    
    useEffect( () => {
        load( { aid: aid, uid: uid } ).then( resp => setLoading( false ) );
    }, [ aid, uid, load ] );

    useEffect( () => {
        let list = [];
        Object.keys( events ).forEach( eid => {
            const e = events[eid];
            if ( name === '' || e.name.toLowerCase().includes( name.toLowerCase() ) ) {
                list.push( e );
            }
        } );
        // setElist( [ ...events.filter( f => name === '' || f.name.toLowerCase().includes( name.toLowerCase() ) ) ] );
        setElist( list );
    }, [ name, events ] );

    useEffect( () => {
        if ( name && name.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ name ] );

    useEffect( () => {
        const today = new Date();
        setEventDate( formatDate( today ) );
        setType( pType.filter( p => p.default ).value );
    }, [ pType ] );

    const create = async () => {
        setProcessing( true );
        const event = {
            name: name,
            location: location,
            type: type,
            date: eventDate,
            start: startTime,
            end: endTime,
            details: details,
            regOption: regOption,
            reg: regLink
        };

        const ppl = ( contacts?.length ) ? contacts : [ cid ];
        console.log( 'adding:', ppl );

        const added = await createEvent( { aid: aid, uid: uid, event: event, contacts: ppl } );
        if ( added.length >= 1 ) {
            toast.success( `${added.length} people have been added to ${event.name}`, { theme: 'dark' } );
            close();
        }
    }

    const add = async ( eid, event ) => {
        setProcessing( true );

        const ppl = ( contacts?.length ) ? contacts : [ cid ];
        
        const added = await addToEvent( { aid: aid, uid: uid, eid: eid, contacts: ppl } );
        if ( added.length >= 1 ) {
            toast.success( `${added.length} people have been added to ${event}`, { theme: 'dark' } );
            close();
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Add To or Create an Event</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Title of the Event</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a title" value={name} onChange={ ( e ) => setName( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                loading ? (
                                    <Container fluid className='text-center py-3'>
                                        <Row><Col><Spinner animation="border" variant='primary' role="status" /></Col></Row>
                                        <Row><Col>Loading Your Active Events</Col></Row>
                                    </Container>
                                ) : (
                                    elist.length > 0 ? (
                                        <Fragment>
                                            <Row>
                                                <Col>All Events:</Col>
                                            </Row>
                                            <Row>
                                                <Col className='ps-0'>
                                                    <ListGroup variant='flush'>
                                                    {
                                                        elist.map( ( e, idx ) => ( 
                                                            <ListGroup.Item key={idx}>
                                                                <Row className='tf-modal-list-item align-items-center'>
                                                                    <Col xs='auto'>{e.name}</Col>
                                                                    <Col>{e.type} on {e.date}</Col>
                                                                    <Col xs='auto'><Button size='sm' variant='outline-primary' onClick={ () => add( e.eid, e.name ) }>+ Add</Button></Col>
                                                                </Row>
                                                            </ListGroup.Item> 
                                                        ) )
                                                    }
                                                    </ListGroup>
                                                </Col>
                                            </Row>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <Row className='py-3'>
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>Date/Time of this event</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type="date" value={eventDate} onChange={ ( e ) => setEventDate( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>Start Time</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type="time" value={startTime} onChange={ ( e ) => setStartTime( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>Stop Time</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type="time" value={endTime} onChange={ ( e ) => setEndTime( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className='py-3'>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Location of this Event</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a location" value={location} onChange={ ( e ) => setLocation( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className='py-3'>
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>Type of Event</Form.Label>
                                                        <Form.Select size='sm' className='tf-modal-text-input' value={type} onChange={ ( e ) => setType( e.target.value ) }>
                                                            <option>Type...</option>
                                                            {
                                                                pType.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className='py-3'>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Details of the Event</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' as="textarea" rows={3} placeholder="Details..." value={details} onChange={ ( e ) => setDetails( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className='py-3'>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Registration Link for this Event</Form.Label>
                                                        <Row>
                                                            <Col xs='auto'><Form.Check
                                                                inline
                                                                label="Don't Need One"
                                                                name='reg'
                                                                type='radio'
                                                                id='no-reg'
                                                                onChange={ ( e ) => setRegOption( 'none' ) }
                                                            /></Col>
                                                            <Col xs='auto'><Form.Check
                                                                inline
                                                                label='Create on Zoom for me'
                                                                name='reg'
                                                                type='radio'
                                                                id='reg-zoom'
                                                                onChange={ ( e ) => setRegOption( 'zoom' ) }
                                                            /></Col>
                                                            <Col xs='auto'><Form.Check
                                                                inline
                                                                label='Let me enter it now'
                                                                name='reg'
                                                                type='radio'
                                                                id='reg'
                                                                onChange={ ( e ) => setRegOption( 'manual' ) }
                                                            /></Col>
                                                        </Row>
                                                        {
                                                            ( regOption === 'manual' ) ? (
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a registration link" value={regLink} onChange={ ( e ) => setRegLink( e.target.value ) } />
                                                                    </Col>
                                                                </Row>
                                                            ) : (
                                                                <Fragment />
                                                            )
                                                        }
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className='py-3'>
                                                <Col xs='auto'>
                                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                                </Col>
                                                <Col xs='auto'>
                                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                                </Col>
                                            </Row>
                                        </Fragment>
                                    )
                                )
                            }
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    cid: state.contacts.currentId,
    pType: state.user.meta.event.picklist.type,
    // events: state.events.names
    events: state.events.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    load: dispatch.events.loadEvents,
    addToEvent: dispatch.events.addContactsToEvent,
    createEvent: dispatch.events.createEvent
} );
  
export default connect( mapProps, mapDispatch )( AddEvent );